import { requestGet } from '@/common/request';

interface ResultData {
  data: groupItem[];
}

type groupItem = {
  groupName: string; //分组名称
  groupId: number; //分组id
  erp: string; //用户erp
  positionNum: 2; //排序位置
  messageSource: string; //消息来源
  messageCode: number; //消息编号
  noticeTip: number; //消息是否弹窗 【0-关闭  1-弹窗】
  noticeMail: number; //消息是否通知邮件 【0-通知 1-不通知】
  noticeDongDong: number; //消息是否通知咚咚【0-通知 1-不通知】
};

/**
 * 消息中心-查询分组
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericGroupSaveGroup(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/group/queryGroupAll');
}
